module.exports = __webpack_public_path__ + "c1aced983ab1e275432d61dd0d362dad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Avatar_Eco8_schwarz@2x.png
// module id = 259
// module chunks = 0